/**
 * MenuOrderPlaceholder — anchor empty state for the Order History list.
 *
 * Renders inside `.dp-orders-page` so styling comes from
 * `_dp-menu-orders.scss .dp-orders-empty`. Native button only — no
 * the legacy button.
 */

import { ReactElement } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { IStore } from "@/redux/defaultStore";
import { merchantSearchRedirect } from "@/utils/merchantSearchRedirect";
import { useGetUserProfile } from "@/hooks/useGetUserProfile";

function MenuOrderPlaceholder(): ReactElement {
    const navigate = useNavigate();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const { data: currentUser } = useGetUserProfile(fullToken);
    const lastSearchedPlaceId = useSelector((store: IStore) => store.metaStore.lastSearchedPlaceId);

    async function handleBrowse(): Promise<void> {
        const redirectRoute = await merchantSearchRedirect(currentUser?.user?.addresses, lastSearchedPlaceId);
        navigate(redirectRoute || "/lootshop");
    }

    return (
        <div className="dp-orders-empty">
            <span className="dp-orders-empty__eyebrow">/ NO ORDERS</span>
            <h3 className="dp-orders-empty__title">Stash is empty</h3>
            <p className="dp-orders-empty__copy">
                Claim a gift card from the LootShop or top up Fuel and your receipts land here.
            </p>
            <button type="button" className="dp-orders-empty__cta" onClick={handleBrowse}>
                Browse LootShop <FaArrowRight />
            </button>
        </div>
    );
}

export default MenuOrderPlaceholder;
